// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let AgentInfo_agent_graphql = require("../../../__generated__/AgentInfo_agent_graphql.bs.js");
let TerminatedAgentIconOverlay = require("./TerminatedAgentIconOverlay.bs.js");

let convertFragment = AgentInfo_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentInfo_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentInfo_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentInfo_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentInfo_agent_graphql.node, convertFragment, fRef);
}

let AgentFragment_membershipStatusV5_decode = AgentInfo_agent_graphql.Utils.membershipStatusV5_decode;

let AgentFragment_membershipStatusV5_fromString = AgentInfo_agent_graphql.Utils.membershipStatusV5_fromString;

let AgentFragment = {
  membershipStatusV5_decode: AgentFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: AgentFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AgentInfo$FromAgent(props) {
  let __size = props.size;
  let __linkToAgent = props.linkToAgent;
  let overrideBrokerage = props.overrideBrokerage;
  let linkToAgent = __linkToAgent !== undefined ? __linkToAgent : true;
  let size = __size !== undefined ? __size : "xSmall";
  let agent = RescriptRelay_Fragment.useFragment(AgentInfo_agent_graphql.node, convertFragment, props.agent);
  let brokerage;
  let displayName;
  let id;
  let profilePhoto;
  let id$1 = agent.id;
  let displayName$1 = agent.displayName;
  let brokerage$1 = agent.brokerage;
  let tmp = agent.membershipStatus;
  if (tmp === "ACTIVE" || tmp === "TERMINATED") {
    if (tmp !== "ACTIVE") {
      return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
        size: size,
        children: JsxRuntime.jsx(AgentInfo__Jsx3.make, {
          avatar: AvatarSrcUrl.place_holder,
          size: size,
          name: displayName$1,
          brokerage: "NO LONGER ON TAN"
        })
      });
    }
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  } else {
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  }
  let avatar = profilePhoto !== undefined ? profilePhoto.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
    avatar: avatar,
    size: size,
    name: Stdlib_Option.getOr(props.overrideDisplayName, displayName),
    brokerage: overrideBrokerage !== undefined ? overrideBrokerage : brokerage,
    wrapName: name => {
      let content = JsxRuntime.jsx("div", {
        children: name,
        className: "font-medium"
      });
      if (linkToAgent) {
        return JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: `/agents/` + id,
          onClick: e => {
            e.stopPropagation();
          },
          children: content
        });
      } else {
        return content;
      }
    },
    children: Stdlib_Option.getOr(props.children, null)
  });
}

let FromAgent = {
  make: AgentInfo$FromAgent
};

function AgentInfo$FromAgentOpt(props) {
  let agent = props.agent;
  if (agent !== undefined) {
    return JsxRuntime.jsx(AgentInfo$FromAgent, {
      agent: Primitive_option.valFromOption(agent),
      size: props.size
    });
  } else {
    return null;
  }
}

let FromAgentOpt = {
  make: AgentInfo$FromAgentOpt
};

let make = AgentInfo$FromAgent;

exports.AgentFragment = AgentFragment;
exports.FromAgent = FromAgent;
exports.FromAgentOpt = FromAgentOpt;
exports.make = make;
/* ButtonsV5 Not a pure module */
